import React, {memo, useState} from "react";

import { TableRowAction } from "../../models";
import { Icon } from "../../../icon";

interface TableRowProps {
  rowClicked: boolean;
  onClick?: () => void;
  rowClickedKey: string;
  children: React.ReactNode;
  actions?: Array<TableRowAction>;
  handleOpenRow?: () => void;
  isOpenNestedChildren?: boolean;
  nestedChildren?: React.ReactNode;
}

const TableRow: React.FC<TableRowProps> = ({
  onClick,
  actions,
  children,
  rowClicked,
  rowClickedKey,
  handleOpenRow,
  nestedChildren,
  isOpenNestedChildren
}) => {
  const [clicked, setClicked] = useState("");

  const handleClick = () => {
    if (rowClicked) {
      setClicked("clicked");
    }
    onClick?.();
  }

  return (
    <div
      onClick={handleClick}
      className={`table-row ${rowClickedKey || clicked ? "clicked" : ""}`}
    >
      <div className={`table-row-inner ${isOpenNestedChildren ? 'open' : ''}`}>
        <div className="table-row-cells">
          <div onClick={handleOpenRow} className="icon-arrow-wrp">
            {
              nestedChildren && (
                <i className="icon-arrow-right"></i>
              )
            }
          </div>
          {children}
        </div>
        {actions?.length ? (
          <div className="table-row-actions-panel">
            {actions.map(({ icon, onClick }) => (
              <Icon
                key={icon}
                type={icon}
                onClick={onClick}
                className="table-row-action"
              />
            ))}
          </div>
        ) : null}
      </div>
      {
        isOpenNestedChildren && (
          nestedChildren
        )
      }
    </div>
  );
};

export default memo(TableRow);
